// extracted by mini-css-extract-plugin
export var divider = "_rl-0";
export var systemMessage = "_rl-1";